import { CarouselNavButtonWrapper } from '@components/MiscComponents/GridAndCarouselComponents/index';
import { color, font, query, space } from '@design/templateFns';
import styled from 'styled-components';

import { Swiper, SwiperSlide } from 'swiper/react';

export const CarouselHeaderWrapper = styled.div`
  margin-bottom: ${space('x5')};
  text-align: center;
  overflow: visible;
  row-gap: ${space('sm')};

  a {
    margin-top: ${space('sm')};
  }

  @media screen and (${query.below('tablet')}) {
    margin: ${space('x5')} auto;
  }
`;

export const CarouselHeadline = styled.h2`
  ${font('headline-md')};
  padding-bottom: 0;
  text-align: center;

  @media screen and (${query.below('tablet')}) {
    ${font('headline-xs')};
  }
`;

export const CarouselHeadlineWithCta = styled(CarouselHeadline)`
  margin-bottom: ${space('sm')};
`;

export const CarouselHeadlineLeft = styled(CarouselHeadline)`
  ${font('headline-sm')};
  margin-bottom: ${space('x7')};
  text-align: left;

  @media screen and (${query.below('tablet')}) {
    ${font('headline-xxs')};
    margin-bottom: ${space('x6')};
  }
`;

export const HeadingAlignCenter = styled.div`
  text-align: center;
`;

export const CarouselHeadlineAlt = styled(CarouselHeadline)`
  ${font('eyebrow-xl')};
  text-transform: uppercase;
  text-align: center;
  margin-bottom: ${space('x12')};

  @media screen and (${query.below('tablet')}) {
    ${font('eyebrow-lg')};
    margin-bottom: ${space('x7')};
  }
`;

//Swiper Styles
export const CarouselSwiper = styled(Swiper)`
  width: 100%;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;

  > .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;

    > .swiper-slide {
      overflow: hidden;
    }

    @media only screen and (min-width: 580px) {
      // special exeption to standard media query for this component
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: ${space('gutterTablet')};
    }

    @media screen and (${query.atLeast('desktop')}) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: ${space('gutter')};
    }
  }

  .swiper-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }
  .swiper-pointer-events {
    touch-action: pan-y;
    &.swiper-vertical {
      touch-action: pan-x;
    }
  }
  .swiper-slide-invisible-blank {
    visibility: hidden;
  }

  /* Auto Height */
  .swiper-autoheight,
  .swiper-autoheight .swiper-slide {
    height: auto;
  }
  .swiper-autoheight .swiper-wrapper {
    align-items: flex-start;
    transition-property: transform, height;
  }
  .swiper-backface-hidden .swiper-slide {
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
`;

export const CarouselSwiperSlide = styled(SwiperSlide)`
  flex-shrink: 0;
  position: relative;
  transition-property: transform;
  display: flex;
  align-items: stretch;

  > div {
    width: 100%;
  }
`;

export const StyledCarouselNavButtonWrapper = styled(CarouselNavButtonWrapper)<{
  $cardType?: string;
}>`
  margin-top: ${({ $cardType }) => ($cardType === 'pressRelease' ? space('x6') : space('xl'))};

  @media only screen and (min-width: 580px) {
    display: none;
  }
`;

export const CarouselCtaWrapper = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${space('x8')};
  text-align: center;
  flex-wrap: wrap;
  grid-gap: 8px;
  justify-content: center;

  @media screen and (${query.below('tablet')}) {
    margin-top: ${space('x6')};
  }
`;

export const NoResultCard = styled.div`
  color: ${color('gray5')};
  text-align: center;
  margin: ${space('x12')} 0;
`;
